module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-13.6dfb2488.png";